"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const FlagEmoji = ({ countryCode }) => {
    switch (countryCode) {
        case 'no':
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "\uD83C\uDDF3\uD83C\uDDF4" });
        case 'dk':
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "\uD83C\uDDE9\uD83C\uDDF0" });
        case 'nl':
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "\uD83C\uDDF3\uD83C\uDDF1" });
        case 'de':
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "\uD83C\uDDE9\uD83C\uDDEA" });
        default:
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "\uD83C\uDDF8\uD83C\uDDEA" });
    }
};
exports.default = FlagEmoji;
